import { render, staticRenderFns } from "./IconeCarrinho.vue?vue&type=template&id=04da51ac&scoped=true&"
import script from "./IconeCarrinho.vue?vue&type=script&lang=ts&"
export * from "./IconeCarrinho.vue?vue&type=script&lang=ts&"
import style0 from "./IconeCarrinho.vue?vue&type=style&index=0&id=04da51ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04da51ac",
  null
  
)

export default component.exports